import request from './request.js';

export const h5FeedbackType = (data) => {
    return request({
        url: '/app/feedback/h5FeedbackType',
        method: 'post',
        data
    });
};
export const h5save = (data) => {
    return request({
        url: '/app/feedback/h5save',
        method: 'post',
        data
    });
};
export const h5list = (data) => {
    return request({
        url: '/app/feedback/h5list',
        method: 'post',
        data
    });
};

/** H5 反馈页：获取 COS 临时上传密钥（仅 PutObject） */
export const h5CosTempToken = (data) => {
    return request({
        url: '/app/feedback/h5CosTempToken',
        method: 'post',
        data: data || {}
    });
};

export const get = (params) => {
    return request({
        url: 'xxxx',
        method: 'get',
        params
    });
};
